import React from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Message } from "semantic-ui-react";
import { withTranslation } from "react-i18next";
import OtherProduct from "~/models/OtherProduct";

const DowngradedSubscriptionItemMessage = observer(
  ({ subscriptionItem, otherProduct, endOfCurrentBillingCycleDate, t }) => (
    <Message warning>
      <Message.Header>
        {t("billingCentral:downgradedSubscriptionItemMessageHeader", { name: otherProduct.name })}
      </Message.Header>
      <p>
        {t("billingCentral:downgradedSubscriptionItemMessage", {
          quantity: subscriptionItem.quantity,
          name: otherProduct.name,
          endOfCurrentBillingCycleDate: endOfCurrentBillingCycleDate.format("MMMM Do YYYY"),
        })}
      </p>
    </Message>
  ),
);

DowngradedSubscriptionItemMessage.propTypes = {
  t: PropTypes.func.isRequired,
  subscriptionItem: PropTypes.object.isRequired,
  otherProduct: PropTypes.instanceOf(OtherProduct),
  endOfCurrentBillingCycleDate: PropTypes.object.isRequired,
};

export default withTranslation()(DowngradedSubscriptionItemMessage);
